function getQueryParameter(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

let loadedData = {};
let form = document.getElementById("prihlaska-v2");
if (localStorage) {
    loadedData = JSON.parse(localStorage.getItem("prihlaska-autosave"));
    if(!loadedData) {
      loadedData = {};
    }
    let qZeme = getQueryParameter("zeme");
    if(qZeme) {
      loadedData["prihlaska[zeme][0][value]"] = qZeme;
    }
    let qMesto = getQueryParameter("mesto");
    if(qMesto) {
      loadedData["prihlaska[zeme][0][mesto][0][value]"] = qMesto;
    }
    let qSkola = getQueryParameter("skola");
    if(qSkola) {
      loadedData["prihlaska[zeme][0][mesto][0][skola][0][value]"] = qSkola;
    }
}

// nastaveni dat do inputu
for (var key in loadedData) {
  let els = document.getElementsByName(key);
  if (els.length > 1) {
    for (let i = 0; i < els.length; i++) {
      let el = els[i];
      if (el.type === "radio") {
        if (el.value == loadedData[key]) {
          el.checked = true;
        }
      }
    }
  } else if (els.length === 1) {
    els[0].value = loadedData[key];
    if (document.createEvent) {
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        els[0].dispatchEvent(evt);
    } else if (CustomEvent) {
      var evt = new CustomEvent("change");
      els[0].dispatchEvent(evt);
    } 
  }
}

// ukladani
setInterval(() => {
  let toSave = {};
  let inputs = form.querySelectorAll("input, select");
  for(let i = 0; i < inputs.length; i++) {
      let input = inputs[i];
      let name = input.getAttribute("name");
      if(name) {
          if(input.type === "radio") {
            if(input.checked) {
                toSave[name] = input.value;
            }
          } else {
            toSave[name] = input.value;
          }
      }
      
  }
  localStorage.setItem("prihlaska-autosave", JSON.stringify(toSave));
}, 10000);


export default loadedData;



// WEBPACK FOOTER //
// ./resources/prihlaska/autosave.js